import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SpacesContainer } from 'src/features/spaces/containers/spaces';
import { meilisearchSearchSchema } from 'src/hooks/meilisearch/schema/meilisearch-search-schema';

export const Route = createFileRoute('/_layout/tenant/spaces/_layout/')({
  component: SpacesContainer,
  validateSearch: zodValidator(meilisearchSearchSchema),
});
